import { TimelineSelectBoxItem } from "@/lib/timeline";
import { Kind } from "@/lib/models/timeline";

/**
 * 翻訳済みタイムラインアイテム種別リストを取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @returns 翻訳済みタイムラインアイテム種別リスト
 */
export const getTranslatedTimelineKinds = (t: (key: string) => string): TimelineSelectBoxItem[] => [
  {
    id: Kind.story,
    name: t("timelinePage.body.kindNames.story"),
    image: "none",
  },
  {
    id: Kind.event,
    name: t("timelinePage.body.kindNames.event"),
    image: "none",
  },
  {
    id: Kind.foreshadowing,
    name: t("timelinePage.body.kindNames.foreshadowing"),
    image: "none",
  },
  {
    id: Kind.payoffForeshadowing,
    name: t("timelinePage.body.kindNames.payoffForeshadowing"),
    image: "none",
  },
  {
    id: Kind.character,
    name: t("timelinePage.body.kindNames.character"),
    image: "none",
  },
  {
    id: Kind.material,
    name: t("timelinePage.body.kindNames.material"),
    image: "none",
  },
  {
    id: Kind.correlation,
    name: t("timelinePage.body.kindNames.correlation"),
    image: "none",
  },
  {
    id: Kind.emotional,
    name: t("timelinePage.body.kindNames.emotional"),
    image: "none",
  },
  {
    id: Kind.volume,
    name: t("timelinePage.body.kindNames.volume"),
    image: "none",
  },
  {
    id: Kind.episode,
    name: t("timelinePage.body.kindNames.episode"),
    image: "none",
  },
  {
    id: Kind.page,
    name: t("timelinePage.body.kindNames.page"),
    image: "none",
  },
  {
    id: Kind.title,
    name: t("timelinePage.body.kindNames.title"),
    image: "none",
  },
  {
    id: Kind.remarks,
    name: t("timelinePage.body.kindNames.remarks"),
    image: "none",
  },
];